<!-- Page Content -->
<ng-container #nav></ng-container>
<toaster-container [toasterconfig]="toasterConfig"></toaster-container>
<ng-progress [spinner]="false"></ng-progress>
<router-outlet></router-outlet>
